var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSizing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_1194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_678_1194",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9976 1.42574C45.7521 1.42574 58.5695 14.2432 58.5695 29.9976C58.5695 45.7521 45.7521 58.5695 29.9976 58.5695C14.2432 58.5695 1.42574 45.7568 1.42574 29.9976C1.42574 14.2384 14.2432 1.42574 29.9976 1.42574ZM29.9976 0C13.4305 0 0 13.4305 0 29.9976C0 46.5648 13.4305 59.9953 29.9976 59.9953C46.5648 59.9953 59.9953 46.5648 59.9953 29.9976C59.9953 13.4305 46.5695 0 29.9976 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.9976 3.42574C44.6475 3.42574 56.5695 15.3477 56.5695 29.9976H60.5695C60.5695 13.1386 46.8567 -0.574257 29.9976 -0.574257V3.42574ZM56.5695 29.9976C56.5695 44.6475 44.6475 56.5695 29.9976 56.5695V60.5695C46.8567 60.5695 60.5695 46.8567 60.5695 29.9976H56.5695ZM29.9976 56.5695C15.3475 56.5695 3.42574 44.6521 3.42574 29.9976H-0.574257C-0.574257 46.8616 13.1388 60.5695 29.9976 60.5695V56.5695ZM3.42574 29.9976C3.42574 15.3432 15.3475 3.42574 29.9976 3.42574V-0.574257C13.1388 -0.574257 -0.574257 13.1336 -0.574257 29.9976H3.42574ZM29.9976 -2C12.3259 -2 -2 12.3259 -2 29.9976H2C2 14.5351 14.5351 2 29.9976 2V-2ZM-2 29.9976C-2 47.6693 12.3259 61.9953 29.9976 61.9953V57.9953C14.5351 57.9953 2 45.4602 2 29.9976H-2ZM29.9976 61.9953C47.6693 61.9953 61.9953 47.6693 61.9953 29.9976H57.9953C57.9953 45.4602 45.4602 57.9953 29.9976 57.9953V61.9953ZM61.9953 29.9976C61.9953 12.3261 47.6743 -2 29.9976 -2V2C45.4647 2 57.9953 14.5349 57.9953 29.9976H61.9953Z",
    fill: "#003053",
    mask: "url(#path-1-inside-1_678_1194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4923 46.503L46.503 13.4923",
    stroke: "#003053",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3354 13.3307H46.6788V22.6645",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6645 46.6646H13.3212V37.3354",
    stroke: "#003053",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43838 34.8166C8.90135 32.9869 8.61145 31.0526 8.61145 29.0471C8.61145 17.76 17.7647 8.61145 29.0518 8.61145C31.0574 8.61145 32.9916 8.90135 34.8213 9.43838",
    stroke: "#DDC77C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5616 24.7034C51.0986 26.5331 51.3885 28.4673 51.3885 30.4729C51.3885 41.76 42.24 50.9133 30.9529 50.9133C28.9473 50.9133 27.0131 50.6234 25.1833 50.0863",
    stroke: "#DDC77C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_1194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizing);
export default __webpack_public_path__ + "static/media/sizing.e79b97bd8e94b2f7d82b8a24fa3f9658.svg";
export { ForwardRef as ReactComponent };